import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Incident from '@/pages/Incident/Incident.vue';
import IncidentList from '@/pages/Incident/IncidentList.vue';
import IncidentForm from '@/pages/Incident/IncidentForm.vue';
import NoPermissions from '@/pages/NoPermissions.vue';
import Callback from '@/pages/Callback.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/incidents'
  },
  {
    path: '/callback',
    component: Callback
  },
  {
    path: '/incidents',
    component: Incident,
    children: [
      {
        path: '',
        component: IncidentList
      },
      {
        path: 'create',
        component: IncidentForm
      },
      {
        path: 'edit/:id',
        component: IncidentForm
      }
    ]
  },
  {
    path: '/nopermissions',
    component: NoPermissions
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
